var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"pt-0":""}},[_c('v-row',_vm._l((_vm.options.results),function(teaser,index){return _c('TeaserCard',{key:index,attrs:{"teaser":teaser}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }